import RestService from './RestService';
import Users from './UsersService';

export default class Lists extends RestService {
    constructor(parentService, companyId) {
        if (parentService && companyId)
            super(`${parentService.baseUrl}/${companyId}/lists`);
        else super('/lists');
    }

    createBatch(listId, data) {
        if (listId)
            return this.post(
                `${this.baseUrl}/${listId}/createUsersBatch`,
                data
            );
        else return this.post(`${this.baseUrl}/createUsersBatch`, data);
    }

    usersService(listId) {
        return new Users(this, listId);
    }

    tags() {
        return this.get(`${this.baseUrl}/tags`);
    }

    createDynamic(data) {
        return this.post(`${this.baseUrl}/dynamic`, data);
    }

    /** Self-add signed-in user to a hidden_on_demand list (after LMS redirect). */
    onDemandSelfEnroll(listId) {
        return this.post(
            `${this.baseUrl}/${encodeURIComponent(listId)}/on-demand-self-enroll`,
            {}
        );
    }

    trainings(listId) {
        return this.get(`${this.baseUrl}/${encodeURIComponent(listId)}/trainings`);
    }

    assessments(listId) {
        return this.get(
            `${this.baseUrl}/${encodeURIComponent(listId)}/assessments`
        );
    }
}
